// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1HdOW","description":"PatientConsentPreview_description__2KK5y"};